<template>
  <v-container>
    <!-- <v-row v-if="this.announcement.length > 0">
      <v-col cols="12" md="12">
        <v-alert
          v-model="whatsnew"
          icon="mdi-fire"
          dark
          text
          elevation="5"
          dismissible
          color="rgb(229,238,248,0.85)"
        >
          <div v-html="this.announcement"></div>
        </v-alert>
        <div class="text-center">
          <v-btn v-if="!whatsnew" text dark @click="whatsnew = true">
            <v-icon left> mdi-fire </v-icon>
            What's New
          </v-btn>
        </div>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="12">
        <v-card flat class="profile-header-card mx-10" rounded="lg" dark>
          <v-card-title class="text-center">
            {{ user.first_name }} {{ user.last_name }}
            <v-btn
              plain
              @click="$router.push({ name: 'ProfileEdit' }, () => {})"
              ><v-icon left dark> mdi-account-edit </v-icon></v-btn
            >
          </v-card-title>
          <v-card-subtitle
            >{{ user.email }}
            <v-chip small color="green" dark class="ml-2" v-if="user.is_active"
              >active</v-chip
            >
            <v-chip
              small
              color="blue"
              dark
              class="ml-2"
              v-if="user.is_superuser"
              >admin</v-chip
            >

            <v-chip
              v-for="group in user.groups"
              :key="group"
              small
              color="blue"
              dark
              class="ml-2"
              >{{ group }}</v-chip
            >
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-10">
          <div v-if="storage_data.length > 0">
            <v-card-title>Storage</v-card-title>
            <v-card-text>
              <div v-for="item in storage_data" :key="item.job">
                {{ getStorageName(item) }}

                <v-progress-linear
                  :color="getStorageColor(item)"
                  :value="getStorageValue(item)"
                  height="25"
                  rounded
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </div>
            </v-card-text>
          </div>
          <v-card-title v-if="servers.length > 0">
            Running Servers
            <v-btn plain @click="$router.push({ name: 'JupyterLab' }, () => {})"
              ><v-icon left dark> mdi-open-in-new </v-icon></v-btn
            >
          </v-card-title>
          <v-card-title v-else>
            No Jupyter servers running
            <v-btn
              plain
              color="primary"
              @click="$router.push({ name: 'JupyterLab' }, () => {})"
            >
              <v-icon left dark>mdi-plus-circle</v-icon> Create new server
            </v-btn>
          </v-card-title>
          <v-card-text v-if="servers.length > 0">
            <v-simple-table dense>
              <tbody>
                <tr v-for="server in servers" :key="server.name" cols="12">
                  <td>
                    <v-btn
                      :disabled="server.ready !== 'Ready'"
                      outlined
                      small
                      color="primary"
                      @click="
                        $router.push(
                          {
                            name: 'JupyterLabView',
                            params: { name: server.name },
                            query: { hub: userStore.hub },
                          },
                          () => {}
                        )
                      "
                      >{{ server.name }}</v-btn
                    >
                  </td>
                  <td>{{ server.type }}</td>
                  <td>{{ server.image }}</td>
                  <td>
                    <v-icon v-if="server.gpu == 1" color="green"
                      >mdi-expansion-card-variant</v-icon
                    >
                  </td>
                  <td><b>Status:</b> {{ server.ready }}</td>
                  <td><b>Last Activity:</b> {{ server.last_activity }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>

          <div v-if="enable_pipelines">
            <v-card-title
              >Jobs
              <v-btn
                plain
                @click="$router.push({ name: 'Pipelines' }, () => {})"
                ><v-icon left dark> mdi-open-in-new </v-icon></v-btn
              ></v-card-title
            >
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="jobs"
                :items-per-page="3"
                class="elevation-0"
                hide-default-header
                hide-default-footer
                dense
              >
              </v-data-table>
            </v-card-text>
          </div>

          <div v-if="(pending.length > 0) & user.is_staff">
            <v-card-title> Pending users </v-card-title>
            <v-card-text>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Username</th>
                    <th>Verified</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="this_user in pending"
                    :key="this_user.username"
                    cols="12"
                  >
                    <td>
                      {{ this_user.first_name }} {{ this_user.last_name }}
                    </td>
                    <td>{{ this_user.email }}</td>
                    <td>{{ this_user.username }}</td>
                    <td>{{ this_user.is_verified }}</td>
                    <td v-if="!this_user.is_active">
                      <v-btn
                        small
                        dark
                        color="success"
                        @click="activateUser(this_user.username)"
                        >activate</v-btn
                      >
                    </td>
                    <td v-else>
                      {{ this_user.is_active }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  ACCOUNTS_ACTIVATE,
  ACCOUNTS_ME,
  ACCOUNTS_PENDING,
  API,
  JUPYTER_USER_SERVERS,
  OWL_PIPELINES,
  S3_USERSTORAGE,
  WHATSNEW,
} from "@/axios-config";
// import { Crisp } from "crisp-sdk-web";
import { useUserStore } from "@/store/user";
import moment from "moment";

export default {
  name: "Profile",
  data() {
    return {
      announcement: "",
      whatsnew: true,
      user: {},
      servers: [],
      images: [],
      jobs: [],
      pending: [],
      ready: false,
      overlay: true,
      storage_data: [],
      headers: [
        { text: "Job", value: "id" },
        { text: "Name", value: "name" },
        { text: "Dataset", value: "dataset" },
        { text: "Status", value: "status" },
      ],
    };
  },
  computed: {
    enable_chat() {
      return process.env.VUE_APP_ENABLE_CHAT == "true";
    },
    enable_pipelines() {
      return process.env.VUE_APP_USE_PIPELINES == "true";
    },
  },
  methods: {
    //
    // Resolve a raw "image:tag" string back to its friendly display name
    //
    imageDisplayName(rawImage) {
      const match = this.images.find((img) => img.name === rawImage);
      return (match && match.text) || (rawImage || "").split("/").pop() || "default";
    },
    //
    // Load available Jupyter docker images (for image display-name lookup)
    //
    async availableImages() {
      try {
        const { data } = await API.get("/api/v1/jhub/images/");
        this.images = data.map((sv, n) => ({
          name: sv["image"] + ":" + sv["tag"],
          text: sv["display"],
          value: n,
          description: sv["description"],
        }));
      } catch (error) {
        console.log(error);
      }
    },
    async checkServers() {
      try {
        // const { data } = await API.get(JUPYTER_USER_SERVERS);
        const { data } = await API.get(JUPYTER_USER_SERVERS, {
          params: { hub: this.userStore.hub },
        });
        data["servers"].forEach((sv) => {
          this.servers.push({
            name: sv["name"] || "default",
            type: sv["user_options"]["server_type"] || "default",
            ready: (sv["ready"] && "Ready") || "Not Ready",
            stopped: sv["stopped"],
            started: moment(sv["started"]).format("DD/MM/YYYY hh:mm"),
            last_activity: moment(sv["last_activity"]).fromNow(),
            image: this.imageDisplayName(sv["user_options"]["image"]),
            gpu:
              sv["user_options"]["extra_resource_limits"]["nvidia.com/gpu"] ||
              0,
          });
        });
      } catch (error) {
        console.log(error);
      }
    },
    async listJobs() {
      try {
        const { data } = await API.get(OWL_PIPELINES, {
          params: { limit: 5 },
        });
        this.jobs = data;
      } catch (error) {
        console.log(error);
      }
    },
    async aboutMe() {
      try {
        const { data } = await API.get(ACCOUNTS_ME);
        this.user = data;
        // this.setupCrisp();
      } catch (error) {
        console.log(error);
      }
      this.queryStorage();
    },
    // setupCrisp() {
    //   // Crisp.setTokenId("");
    //   // Crisp.session.reset();
    //   if (!this.enable_chat) {
    //     return;
    //   }
    //   Crisp.setTokenId(this.user.jupyter_access_token);
    //   Crisp.session.reset();
    //   Crisp.user.setEmail(this.user.email);
    //   Crisp.user.setNickname(this.user.first_name + " " + this.user.last_name);
    //   Crisp.session.setData({
    //     user: this.user.username,
    //   });
    //   Crisp.session.pushEvent("login");
    //   Crisp.load();
    //   // Send what's new message
    //   // Crisp.message.show("text", "");
    //   // Crisp.message.startThread("Ticket #152239");
    //   // Crisp.message.endThread();
    // },
    async pendingUsers() {
      try {
        const { data } = await API.get(ACCOUNTS_PENDING);
        this.pending = data;
      } catch (error) {
        console.log(error);
      }
    },
    async activateUser(username) {
      try {
        await API.post(ACCOUNTS_ACTIVATE, { username: username });
        await this.pendingUsers();
      } catch (error) {
        console.log(error);
      }
    },
    async queryStorage() {
      try {
        const { data } = await API.get(S3_USERSTORAGE);
        if (data.status == "success") {
          this.storage_data = data.data.result;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getAnnouncement() {
      // try {
      fetch(WHATSNEW)
        .then((response) => {
          if (response.status !== 200) {
            return "";
          }
          return response.text();
        })
        .then((data) => {
          this.announcement = data;
        });
      //   this.announcement = data.text();
      //   console.log(this.announcement.result);
      // } catch (error) {
      //   console.error(error);
      // }
    },
  },

  mounted: function () {
    console.log(process.env);
    this.$nextTick(async function () {
      this.aboutMe();
      await this.availableImages();
      this.checkServers();
      this.listJobs();
      this.pendingUsers();
      this.getAnnouncement();
      // this.setupCrisp();
    });
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
};
</script>

<style scoped>
.profile-header-card.v-card {
  background-color: rgba(16, 16, 20, 0.65) !important;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
</style>